import LogoutIcon from '@mui/icons-material/Logout'
import { IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { useTranslate, useLogout } from 'react-admin'

export const UserMenu: FC = () => {
  const translate = useTranslate()
  const logout = useLogout()

  const handleLogout = () => void logout()

  return (
    <Root>
      <IconButton
        aria-label={translate('ra.auth.user_menu')}
        aria-haspopup={true}
        color="inherit"
        onClick={handleLogout}
      >
        <LogoutIcon sx={{ color: '#fff'}}/>
      </IconButton>
    </Root>
  )
}

const PREFIX = 'xxllncUserMenu'

const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
  avatar: `${PREFIX}-avatar`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.button}`]: {
    color: '#fff!important',
  },
  [`& .${classes.avatar}`]: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  ['& span']: {
    marginRight: '5px',
  },
}))
